import loadable from '@loadable/component';

export const ConsultantPopupContainerLoadable = loadable(() => {
  if (process.env.IS_BROWSER_BUILD) {
    return import('./ConsultantPopup');
  }

  return Promise.resolve({
    default: () => null,
  });
});
